const FontFaceObserver = require('fontfaceobserver');
export const ffoScript = document.createElement('script');
const html = document.documentElement;

const params = {
    ffoPath: '/_assets/dist/js/vendors/fontfaceobserver.js',
    expirationDays: 30,
    cookieName: 'fonts-loaded',
    loadedClass: 'js-fonts-loaded'
};

// ======================================================================  //
// Functions
// ======================================================================  //

/**
 * @function `loadFfoAsynchronously`
 *
 * Loads the font-face observer asynchronously.
 */
export const loadFfoAsynchronously = () => {
    ffoScript.src = params.ffoPath;
    ffoScript.async = true;
    document.head.appendChild(ffoScript);
}

/**
 * @function `setCookie`
 *
 * Set a cookie for a defined period of time.
 */
function setCookie () {
    const d = new Date();
    d.setTime(d.getTime() + (params.expirationDays * 24 * 60 * 60 * 1000));
    const expirationDate = d.toUTCString();
    document.cookie = params.cookieName + '=true;expires=' + expirationDate;
}

function applyWebfonts () {
    document.documentElement.classList.add(params.loadedClass);
}

/**
 * @function `loadFonts`
 *
 * Loads the fonts asynchronously and shows them once they have all loaded.
 * After that, the cookie is set.
 *
 * 1. If the cookie exists, webfonts are applied directly.
 */
export const loadFonts = () => {
    var event = new window.CustomEvent('fontsLoaded');
    if (html.className.indexOf(params.loadedClass) > -1) {
        window.dispatchEvent(event);
        return; /* [1] */
    }
    var cecoforma = new FontFaceObserver('Cecoforma');
    Promise.all([
        cecoforma.load()
    ]).then(function () {
        applyWebfonts();
        setCookie();
        window.dispatchEvent(event);
    }, function () {
        // Fonts unavailable
    });
}
